import { Loader } from "@app/components/core/Loader/Loader"
import { SelectionEntry } from "@app/components/core/SelectionEntry/SelectionEntry"
import Button from "@app/components/move2Library/Button/Button"
import { addKioskVoucher } from "@app/store/actions/orderActions"
import { useGetVouchers } from "@app/store/service/cmsService"
import { useDelayLoading } from "@app/utils/hooks/useDelayLoading"
import { getPriceString } from "@app/utils/localeUtils"
import { Modal, useModal } from "@tecreation/funnel-components"
import { EmployeePriceModal } from "./EmployeePriceModal"

export default function EmployeeFunnelVoucherModal() {
	const { hideModal, showModal } = useModal()

	const { data: vouchers, isFetching } = useGetVouchers()

	const loading = useDelayLoading(isFetching, 200)

	return (
		<Modal>
			<Modal.Closer />
			<Modal.Header>Gutscheine</Modal.Header>
			<Modal.Body>
				<Loader show={loading} />

				{!loading && (
					<>
						{vouchers && vouchers.length === 0 && <div className="f3 color-fg-danger">Keine Gutscheine verfügbar</div>}

						{vouchers && vouchers.length > 0 && (
							<div style={{ minWidth: "400px" }}>
								{vouchers.map((voucher, index) => {
									return (
										<SelectionEntry
											onAdd={() => {
												if (voucher.openPrice === true) {
													showModal(EmployeePriceModal, { voucher })
												} else {
													addKioskVoucher(voucher)
													hideModal()
												}
											}}
											key={index}
										>
											<div className="flex flex-justify-between">
												<div>{voucher.article}</div>
												<div>{getPriceString(voucher.price)}</div>
											</div>
										</SelectionEntry>
									)
								})}
							</div>
						)}
					</>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button style="danger" onClick={hideModal}>
					Schliessen
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
